import React from 'react';

import { Text } from '@thinkific/chalk/react-components';
import { classNames } from '@thinkific/chalk/utils';

import * as css from './SiteNavMenuItem.css';

interface SiteNavMenuIconProps {
  icon: React.ElementType;
  statusIndicator?: React.ReactNode;
  label: string;
  active?: boolean;
  onClick?: () => void;
}

const SiteNavMenuItem = ({
  icon,
  statusIndicator,
  label,
  active,
  onClick,
}: SiteNavMenuIconProps) => {
  const Icon = icon;

  return (
    <li>
      <button
        className={classNames(css.menuItem, active && css.menuItemActive)}
        type="button"
        onClick={onClick}
      >
        <span
          className={classNames(
            css.menuItemIcon,
            active && css.menuItemIconActive,
            statusIndicator ? css.statusIndicator : ''
          )}
        >
          <Icon filled={active} />
        </span>
        {statusIndicator}
        <Text as="span" variant="help-text.xs">
          {label}
        </Text>
      </button>
    </li>
  );
};

export default SiteNavMenuItem;
